export const selectApplySteps = (state) => state.apply.applySteps;
export const selectPermitApplicationData = (state) =>
  state.apply?.applicationData;
export const selectDocumentUploadStarted = (state) =>
  state.apply?.documentUploadStarted;
export const selectDocumentUploadWorking = (state) =>
  state.apply?.documentUploadWorking;
export const selectDocumentUploadCompleted = (state) =>
  state.apply?.documentUploadCompleted;
export const selectDocumentUploadErrors = (state) =>
  state.apply?.documentUploadErrors;
export const selectPermitApplicationRegistrant = (state) =>
  state.apply?.applicationData?.registrant;
export const selectApplicationNumber = (state) =>
  state.apply?.applicationNumber;
export const selectApplicationIsPaymentRequired = (state) => {
  const { fee, custom_fee, fee_override, custom_fee_multiple_answers } =
    state.config?.settings?.express?.registration?.application;

  return (
    (fee && fee !== 0) ||
    custom_fee ||
    fee_override ||
    custom_fee_multiple_answers
  );
};
